"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { CircleAlert, RefreshCw } from "lucide-react";
function BlogPostsGrid() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden">
            <div className="aspect-[16/10] w-full animate-pulse bg-muted" />
            <CardHeader>
              <div className="h-6 w-3/4 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-4 w-full animate-pulse rounded bg-muted" />
              <div className="mt-1 h-4 w-2/3 animate-pulse rounded bg-muted" />
            </CardHeader>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center rounded-xl border border-border bg-muted/30 p-12 text-center">
        <CircleAlert className="mb-4 size-10 text-muted-foreground" />
        <p className="mb-4 text-lg font-medium text-foreground">
          Failed to load market insights.
        </p>
        <Button variant="outline" onClick={refetch}>
          <RefreshCw className="mr-2 size-4" />
          Try Again
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="flex flex-col items-center justify-center rounded-xl border border-border bg-muted/30 p-12 text-center">
        <p className="text-lg font-medium text-foreground">
          No market insights available at the moment.
        </p>
        <p className="text-muted-foreground">Check back later for updates.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex h-full flex-col overflow-hidden transition-shadow hover:shadow-md">
          <Link to={post.link || "#"} className="relative block aspect-[16/10] w-full overflow-hidden">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1584719/img/kc_market_placeholder.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="absolute left-4 top-4">
              <Badge variant="secondary" className="shadow-sm">
                Market Update
              </Badge>
            </div>
          </Link>
          <CardHeader className="flex-1 pb-6">
            <CardTitle className="line-clamp-2 text-xl leading-tight">
              <Link to={post.link || "#"} className="transition-colors hover:text-primary">
                {post.title}
              </Link>
            </CardTitle>
            {post.excerpt && <CardDescription className="mt-3 line-clamp-2 text-base">
                <span dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />
              </CardDescription>}
          </CardHeader>
        </Card>)}
    </div>;
}
export default function KansasCityRentalMarketInsights() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="kansas-city-rental-market-insights" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            Kansas City Rental Market Insights
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Stay informed on the latest trends, investment opportunities, and
            regulatory changes in the Kansas City metropolitan rental market.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <BlogPostsGrid />
        </PostsProvider>
      </div>
    </section>;
}